export const svgHeight = 21;
export const getCircleRadius = isMobile => {
  if (isMobile) {
    return 8;
  }
  return 4;
};
export const circleRadius = 8;